import { render, staticRenderFns } from "./AuroraFooter.vue?vue&type=template&id=16d6bca0"
import script from "./AuroraFooter.vue?vue&type=script&lang=js"
export * from "./AuroraFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports